namespace advisorop.components.advisor {
    
    class AssignRtgFormController {
        $router;          
        account: domains.IAccount;
        
        static $inject = ["advisorService", "accountApi"];
        constructor(private advisorService: services.AdvisorService,
            private accountApi: services.AccountApi) {           
        }

        loadAccount(accountId: number) {
            this.accountApi.getById(accountId)
                .success((data) => {
                    this.account = data;
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });

        };

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.loadAccount(<number>next.params.accountId);
        }
    }


    class AssignRtgForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        $canActivate;

        constructor() {
            this.controller = AssignRtgFormController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/advisor-module/views/assign-rtg-form.html";
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable Assign RTG functionality");
                    return false;
                }
                return true;
            }];
        }        
    }
    angular.module(Constants.APP).component("assignRtgForm", new AssignRtgForm());


}